import { render, staticRenderFns } from "./RegistrationClient.vue?vue&type=template&id=7f9f0980&scoped=true&lang=pug&"
import script from "./RegistrationClient.vue?vue&type=script&lang=js&"
export * from "./RegistrationClient.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationClient.vue?vue&type=style&index=0&id=7f9f0980&prod&lang=scss&"
import style1 from "./RegistrationClient.vue?vue&type=style&index=1&id=7f9f0980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9f0980",
  null
  
)

export default component.exports